// extracted by mini-css-extract-plugin
export default {"canvas":"wZdNnd","hidden":"x_XXqG","visuallyHidden":"iASZMs"};